enum RouteDetailsMapMarkerType {
  ONBOARDING = "ONBOARDING",
  OUTBOARDING = "OUTBOARDING",
  STANDARD = "STANDARD",
  WEATHERED = "WEATHERED",
}

export default RouteDetailsMapMarkerType;
